import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Icon, Menu } from "semantic-ui-react";
import TourLayoutWrapper from "../components/TourLayoutWrapper";
import TourNav from "../constants/TourNav";
import TourStore from "~/stores/TourStore";
import ContentLoader from "~/components/element/ContentLoader";
import Immersive3dTourExportAdMessage from "~/components/Immersive3dTourExportAdMessage";
import StickyMenu from "~/components/StickyMenu";
import Loader from "../components/Loader";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import "../styles/Immersive3dTour.less";

@observer
class Immersive3dTourPage extends Component {
  /**
   * @type {Immersive3dTourPlayerStore}
   */
  immersive3dTourPlayerStore;

  constructor(props) {
    super(props);
    document.title = "Tour - Immersive 3D Tour";
  }

  render() {
    const { tourStore, t, tourLayoutContentContainerRef } = this.props;
    const { tour } = tourStore;
    const { immersive3dTour, checkoutPageLinks } = tour;
    const { otherProduct1CheckoutPageLink } = checkoutPageLinks;

    if (!tourStore.tourLoaded) {
      return <ContentLoader />;
    }

    let immersive3dTourPlayerContent = null;

    if (tour.hasReadiedImmersive3dTour) {
      immersive3dTourPlayerContent = (
        <>
          <Menu vertical>
            <Menu.Item
              href={`${window.location.protocol}//${window.location.hostname}/immersive-3d-tours/${immersive3dTour.tourId}/edit`}
              target="_blank"
            >
              <Icon name="external alternate" />
              {t("edit")}
            </Menu.Item>
          </Menu>

          <iframe
            title="Immersive 3D Tour"
            src={`/immersive-3d-tours/${immersive3dTour.tourId}/`}
            className="immersive3dTourEditionPlayer"
          />
        </>
      );
    }
    return (
      <>
        <StickyMenu contextRef={tourLayoutContentContainerRef} headerText={t("immersive3dTour")} />

        <Loader active={tourStore.isLoading} page content={t("loading")} />

        <Immersive3dTourExportAdMessage
          tourHasReadiedImmersive3dTour={tour.hasReadiedImmersive3dTour}
          otherProduct1CheckoutPageLink={otherProduct1CheckoutPageLink}
        />

        {immersive3dTourPlayerContent}
      </>
    );
  }
}

Immersive3dTourPage.propTypes = {
  tourId: PropTypes.number.isRequired,
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
  tourLayoutContentContainerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default withTranslation()(ErrorWrapper(TourLayoutWrapper(Immersive3dTourPage, TourNav.IMMERSIVE_3D_TOUR)));
